// External libraries
import { ApolloClient } from 'apollo-client';

// Internal modules
import { cache } from './cache';
import { getLinks } from './links';
import { requestFactoryMutate, requestFactoryQuery } from './utils';
import { getGlobals, getLocale, getToken } from '../globals';
// @ts-expect-error untyped-import
import INITIAL_DATA_QUERY from '@/initialDataQuery.graphql';

export const apolloClient = new ApolloClient({
  cache,
  link: getLinks(),
  queryDeduplication: true,
  resolvers: {},
});

// Seed the cache with the initial data query from the server
const { country: countryCode, language: languageCode } = getLocale();
const { fundingSource } = window.xprops || {};
const { device, initialGqlData, isBasl } = getGlobals();

apolloClient.writeQuery({
  data: initialGqlData,
  query: INITIAL_DATA_QUERY,
  variables: {
    channel: device.channel,
    countryCode,
    countryCodeAsString: countryCode,
    fundingSource,
    isBasl,
    isBaslAsString: `${isBasl}`,
    languageCode,
    token: getToken(),
  },
});

export const apolloMutation = requestFactoryMutate(apolloClient);

export const apolloQuery = requestFactoryQuery(apolloClient);
